/**
 * SkipLink — the bypass past the page chrome to the main content, and the first
 * thing a keyboard reaches on every page.
 *
 * Corpus: `PR1:28` (public landing, above the sticky
 * header), `DB:25` (app shell, above the sidebar) and
 * `JC:25` — one green pill in all three, parked
 * off-screen and brought back by focus. (Those three park it at
 * `translateY(-300%)`, 8px in from the top and the inline start, where this
 * stylesheet uses -200% and `--rp-space-3`: a divergence recorded rather than
 * quietly reconciled, because this move is not the place to change behaviour.)
 *
 * The label is a prop, never a literal in this file: the corpus already reads
 * it from a catalogue (`{{ ui.skipTo }}`), and `apps/web` passes the translated
 * string in.
 */
export interface SkipLinkProps {
  readonly targetId: string;
  readonly label: string;
}

export function SkipLink({ targetId, label }: SkipLinkProps) {
  return (
    <a className="rp-skip-link" href={`#${targetId}`}>
      {label}
    </a>
  );
}
